import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './stickyForm';
import List from './stickyList';

const settings = {
    pathRegister: paths.stickRegister,
    pathList: paths.stick,
    apiPath: 'sticks',
    permissionAdmin: null,
    title: 'Vara',
};

const FormEntity: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const ListEntity: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { FormEntity, ListEntity };
